import Vue from 'vue';
import Router from 'vue-router';

let commonRoutes = require('../router/routes-common').default; // Common routes used by both Professional and Pathfinder modules.
let pathfinderRoutes = require('../../pathfinder/router/routes-pathfinder').default; // Routes used only by Pathfinder module.

let professionalRoutes = [];
if (typeof process.env.HAS_PROFESSIONAL_MODULE !== "undefined" && process.env.HAS_PROFESSIONAL_MODULE === true) {
    professionalRoutes = require('../../professional/router/routes-pro').default; // Routes used only by Professional module.
}

Vue.use(Router);

let allRoutes = [].concat(
    commonRoutes,
    professionalRoutes,
    pathfinderRoutes
);

let appRouter = new Router({
    //mode: 'history',
    routes: allRoutes
});

appRouter.beforeEach((to, from, next) => {
    // Only go to a new route after all ajax requests are successfully done.
    if ( !Vue.AjaxHelper.hasPendingAjaxRequests() ) {
        // Do not start a setTimeout loop if it's not needed.
        next(); // Redirect to the new route
    }
    else {
        let intervalIndex = setInterval(() => {

            if (!Vue.AjaxHelper.hasPendingAjaxRequests()) {
                if (intervalIndex) {
                    clearInterval(intervalIndex);
                }

                let isRouteChangeCanceled = (Vue.AjaxHelper.hasFailedRequests()) ? true : false;
                Vue.AjaxHelper.resetFailedRequestsCounter();

                if (!isRouteChangeCanceled) {
                    next(); // Redirect to the new route
                }
            }
        }, 50);
    }
});

export default appRouter;



// WEBPACK FOOTER //
// ./src/common/router/router.js